module.exports = __webpack_public_path__ + "static/media/icone-ia-degrade.7ce339a6.svg";